import {useParams, useNavigate} from "react-router-dom"
import useTeam from "../../swrCustomHooks/useTeam"
import useTeamOverview from "../../swrCustomHooks/useTeamOverview"
import useTeamHistory from "../../swrCustomHooks/useTeamHistory"
import LoadingComponent from "../../components/loading-component/LoadingComponent"
import TeamDashboardHeader from "../../sections/team-dashboard-header/TeamDashboardHeader"
import TeamDashboardContent from "../../sections/team-dashboard-content/TeamDashboardContent"
import NeurowideDashboardModal from "../../sections/neurowide-dashboard-modal/NeurowideDashboardModal"
import ConfirmationModal from "../../components/confirmation-modal/ConfirmationModal"
import axios from "axios"
import {API_TEAMS} from "../../constants/apiUrls"
import RequireIsAdmin from "../../tools/RequireIsAdmin"
import {useTranslation} from "react-i18next"
import {toast} from "react-toastify"
import TeamDashboardFooter from "../../sections/team-dashboard-footer/TeamDashboardFooter"
import {useSessionContext} from "../../reactContext/contextCustomHooks/useSessionContext"
import {useNwDashboardContext} from "../../reactContext/contextCustomHooks/useNwDashboardContext"
import useTeams from "../../swrCustomHooks/useTeams"

export default function TeamDashboard() {
    const {t} = useTranslation()
    const {sessionContext} = useSessionContext()
    const {nwDashboardContext} = useNwDashboardContext()
    let params = useParams()
    const navigate = useNavigate()
    const {mutateTeams} = useTeams()
    const {team, mutateTeam, isLoadingTeam, isErrorTeam} = useTeam(params.teamID)
    const {teamOverview, mutateTeamOverview, isLoadingTeamOverview, isErrorTeamOverview} = useTeamOverview(params.teamID)
    const {teamHistory, isLoadingTeamHistory, isErrorTeamHistory} = useTeamHistory(params.teamID, nwDashboardContext.teamPage)

    const deleteLicence = (value) => {
        return new Promise((resolve, reject) => {
            if (value) {
                const headersRequest = {headers: {Authorization: `Bearer ${sessionContext.idToken}`}}
                axios.delete(`${API_TEAMS}/${nwDashboardContext.isConfirmationModal.id}`, headersRequest)
                .then(() => {
                    mutateTeams()
                    navigate("/neurowide-dashboard")
                    toast.success(t("Licence removed"))
                    resolve()
                })
                .catch((error) => {
                    console.error("DELETE /teams/team: ", error)
                    toast.error(t("This team still has projects and cannot be disable"))
                    reject()
                })
            } else {
                resolve()
            }
        })
    }

    if (isErrorTeam || isLoadingTeam || team.message
        || isErrorTeamOverview || isLoadingTeamOverview || teamOverview.message
        || isErrorTeamHistory || isLoadingTeamHistory || teamHistory.message) return <LoadingComponent/>
    return (
        <>
        <RequireIsAdmin role={sessionContext.role} redirect={true}>
            <div className="VIEW TEAM-DASHBOARD">
                <NeurowideDashboardModal team={team} type={"update"} mutateTeams={mutateTeams} mutateTeam={mutateTeam} mutateTeamOverview={mutateTeamOverview}/>
                {nwDashboardContext.isConfirmationModal.modal && <ConfirmationModal type={"team"} deleteLicence={deleteLicence}/>}
                <TeamDashboardHeader team={teamOverview.team}/>
                <TeamDashboardContent teamOverview={teamOverview} adminID={team.team.id_admin} teamHistory={teamHistory}/>
                <TeamDashboardFooter teamID={params.teamID}/>
            </div>
        </RequireIsAdmin>
        </>
    )
}